import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./Footer";
import useSettings from "../../hooks/useSettings";

const FP_CSS = `
  .fp-page { min-height: 100vh; background: #fff; }

  /* HERO */
  .fp-hero {
    padding: 120px 32px 80px;
    background: #07090f;
    position: relative; overflow: hidden;
  }
  .fp-hero__mesh {
    position: absolute; inset: 0; z-index: 0; pointer-events: none;
    background:
      radial-gradient(ellipse 70% 60% at 15% 30%, rgba(37, 99, 235,.2) 0%, transparent 65%),
      radial-gradient(ellipse 50% 50% at 85% 20%, rgba(37,99,235,.15) 0%, transparent 60%);
  }
  .fp-hero__inner {
    max-width: 860px; margin: 0 auto; position: relative; z-index: 1;
    text-align: center;
  }
  .fp-hero__tag {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(37, 99, 235,.15); border: 1px solid rgba(37, 99, 235,.3);
    border-radius: 100px; padding: 6px 16px;
    font-size: 12px; font-weight: 600; color: #93C5FD; margin-bottom: 28px;
    letter-spacing: .5px; text-transform: uppercase;
  }
  .fp-hero__title {
    font-size: clamp(32px, 5vw, 60px); font-weight: 700;
    color: #fff; line-height: 1.1; letter-spacing: -1.5px; margin-bottom: 20px;
  }
  .fp-hero__title span {
    background: linear-gradient(135deg, #60A5FA, #60a5fa);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .fp-hero__sub {
    font-size: 18px; color: rgba(255,255,255,.6); line-height: 1.65;
    max-width: 560px; margin: 0 auto 40px;
  }
  .fp-hero__btn {
    display: inline-flex; align-items: center; gap: 8px;
    background: linear-gradient(135deg, #2563EB, #2563eb); color: #fff; border: none;
    padding: 14px 36px; border-radius: 12px;
    font-size: 15px; font-weight: 600; cursor: pointer;
    box-shadow: 0 8px 28px rgba(37, 99, 235,.35); font-family: inherit;
    transition: transform .2s, box-shadow .2s;
  }
  .fp-hero__btn:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(37, 99, 235,.45); }

  /* FEATURES LIST */
  .fp-sec { padding: 88px 32px; }
  .fp-sec--bg { background: #f8f7ff; }
  .fp-wrap { max-width: 1100px; margin: 0 auto; }
  .fp-tag {
    display: inline-flex; align-items: center;
    background: #EFF6FF; color: #2563EB; border-radius: 100px;
    padding: 5px 14px; font-size: 11px; font-weight: 600; letter-spacing: .5px;
    text-transform: uppercase; margin-bottom: 14px;
  }
  .fp-h2 {
    font-size: clamp(24px, 3vw, 38px); font-weight: 700;
    color: #0f0f23; line-height: 1.2; letter-spacing: -.4px; margin-bottom: 14px;
  }
  .fp-sub { font-size: 16px; color: #6b7280; line-height: 1.65; max-width: 520px; margin-bottom: 52px; }
  .fp-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  @media (max-width: 860px) { .fp-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 540px) { .fp-grid { grid-template-columns: 1fr; } }
  .fp-card {
    background: #fff; border-radius: 18px; padding: 28px 24px;
    border: 1px solid #e8eaed;
    box-shadow: 0 1px 3px rgba(0,0,0,.04), 0 4px 16px rgba(0,0,0,.04);
    transition: transform .25s, box-shadow .25s;
  }
  .fp-card:hover { transform: translateY(-4px); box-shadow: 0 4px 8px rgba(0,0,0,.04), 0 16px 40px rgba(0,0,0,.08); }
  .fp-card__icon {
    width: 48px; height: 48px; border-radius: 13px;
    display: flex; align-items: center; justify-content: center; margin-bottom: 16px;
  }
  .fp-card h3 { font-size: 16px; font-weight: 700; color: #0f0f23; margin-bottom: 8px; }
  .fp-card p { font-size: 14px; color: #6b7280; line-height: 1.6; }

  /* HOW SECTION */
  .fp-how { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; }
  @media (max-width: 860px) { .fp-how { grid-template-columns: 1fr; gap: 36px; } }
  .fp-steps { display: flex; flex-direction: column; }
  .fp-step { display: flex; gap: 16px; }
  .fp-step__left { display: flex; flex-direction: column; align-items: center; flex-shrink: 0; }
  .fp-step__num {
    width: 38px; height: 38px; border-radius: 10px;
    background: #EFF6FF; display: flex; align-items: center;
    justify-content: center; font-size: 14px; font-weight: 700; color: #2563EB;
  }
  .fp-step__line { width: 1px; flex: 1; background: #e8eaed; min-height: 18px; margin: 5px 0; }
  .fp-step:last-child .fp-step__line { display: none; }
  .fp-step__body { padding: 4px 0 24px; }
  .fp-step:last-child .fp-step__body { padding-bottom: 0; }
  .fp-step h4 { font-size: 15px; font-weight: 700; color: #0f0f23; margin-bottom: 4px; }
  .fp-step p { font-size: 14px; color: #6b7280; line-height: 1.6; }
  .fp-how__img {
    border-radius: 20px; border: 1px solid #e8eaed; overflow: hidden;
    box-shadow: 0 8px 32px rgba(0,0,0,.08);
    background: linear-gradient(145deg, #EFF6FF, #dbeafe);
    aspect-ratio: 4/3; display: flex; align-items: center; justify-content: center;
  }
  .fp-how__img-inner { text-align: center; padding: 24px; }
  .fp-how__img-label {
    font-size: 22px; font-weight: 700;
    background: linear-gradient(135deg, #2563EB, #2563eb);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    background-clip: text; margin-top: 16px;
  }
  .fp-how__img-sub { font-size: 14px; color: #6b7280; margin-top: 6px; }

  /* CTA */
  .fp-cta {
    background: linear-gradient(135deg, #2563EB, #2563eb);
    padding: 80px 32px; text-align: center;
  }
  .fp-cta__inner { max-width: 560px; margin: 0 auto; }
  .fp-cta__title { font-size: clamp(26px, 3.5vw, 40px); font-weight: 700; color: #fff; letter-spacing: -.4px; margin-bottom: 14px; }
  .fp-cta__sub { font-size: 16px; color: rgba(255,255,255,.72); margin-bottom: 36px; line-height: 1.6; }
  .fp-cta__btn {
    display: inline-flex; align-items: center; gap: 8px;
    background: #fff; color: #2563EB; border: none;
    padding: 14px 36px; border-radius: 12px; font-size: 15px; font-weight: 700;
    cursor: pointer; box-shadow: 0 8px 24px rgba(0,0,0,.15); font-family: inherit;
    transition: transform .2s, box-shadow .2s;
  }
  .fp-cta__btn:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(0,0,0,.2); }
  .fp-back {
    display: inline-flex; align-items: center; gap: 6px; margin-top: 24px;
    font-size: 14px; font-weight: 500; color: rgba(255,255,255,.7);
    background: none; border: none; cursor: pointer; font-family: inherit;
    transition: color .2s;
  }
  .fp-back:hover { color: #fff; }
`;

const FeaturePageLayout = ({ tag, title, titleHi, sub, cards, steps, visual }) => {
  const history = useHistory();
  const { getPublicSetting } = useSettings();
  const [appName, setAppName] = useState("");

  useEffect(() => {
    getPublicSetting("appName").then(v => { if (v) setAppName(v); }).catch(() => {});
  }, []);

  const scroll = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="fp-page">
      <style>{FP_CSS}</style>
      <LandingHeader scrollTo={scroll} />

      {/* HERO */}
      <section className="fp-hero">
        <div className="fp-hero__mesh" />
        <div className="fp-hero__inner">
          <div className="fp-hero__tag">{tag}</div>
          <h1 className="fp-hero__title">
            {title}<br />
            <span>{titleHi}</span>
          </h1>
          <p className="fp-hero__sub">{sub}</p>
          <button className="fp-hero__btn" onClick={() => history.push("/cadastro")}>
            Começar gratuitamente →
          </button>
        </div>
      </section>

      {/* FEATURE CARDS */}
      <section className="fp-sec">
        <div className="fp-wrap">
          <div className="fp-tag">O que você ganha</div>
          <h2 className="fp-h2">Tudo em um único lugar</h2>
          <p className="fp-sub">Ferramentas integradas para maximizar seus resultados sem complexidade.</p>
          <div className="fp-grid">
            {cards.map((c, i) => (
              <div key={i} className="fp-card">
                <div className="fp-card__icon" style={{ background: c.bg }}>{c.icon}</div>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      {steps && (
        <section className="fp-sec fp-sec--bg">
          <div className="fp-wrap">
            <div className="fp-how">
              <div>
                <div className="fp-tag">Como funciona</div>
                <h2 className="fp-h2" style={{ marginBottom: 36 }}>Do zero ao resultado em minutos</h2>
                <div className="fp-steps">
                  {steps.map((s, i) => (
                    <div key={i} className="fp-step">
                      <div className="fp-step__left">
                        <div className="fp-step__num">0{i + 1}</div>
                        <div className="fp-step__line" />
                      </div>
                      <div className="fp-step__body">
                        <h4>{s.title}</h4>
                        <p>{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="fp-how__img">
                <div className="fp-how__img-inner">
                  {visual.icon}
                  <div className="fp-how__img-label">{visual.label}</div>
                  <div className="fp-how__img-sub">{visual.sub}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <div className="fp-cta">
        <div className="fp-cta__inner">
          <h2 className="fp-cta__title">Pronto para transformar seu negócio?</h2>
          <p className="fp-cta__sub">
            Junte-se a mais de 500 empresas que já usam {appName} para crescer com inteligência.
          </p>
          <button className="fp-cta__btn" onClick={() => history.push("/cadastro")}>
            Criar conta gratuita →
          </button>
          <br />
          <button className="fp-back" onClick={() => history.push("/")}>
            ← Voltar ao início
          </button>
        </div>
      </div>

      <LandingFooter appName={appName} />
    </div>
  );
};

export default FeaturePageLayout;
